import React from 'react';
import { 
    Table, 
    TableBody, 
    TableCell, 
    TableContainer,
    TableHead, 
    TableRow, 
    Paper 
} from '@mui/material';
import TracksPlayPauseButton from '../tracks-play-pause/tracks-play-pause';
import { cleanStemName } from '../../utils/utils';
// import WaveFormVisualizer from '../wave-form/wave-form-visualizer';
import WaveForm from '../wave-form/new-wave-form';
import './stem-list.css';


const StemList = ({trackList, parentTrackTitle}) => {

    return (
        <div className='stem-list-container'>
            <TableContainer 
                component={Paper} 
                sx={{ 
                    margin:'0px 40px 80px 40px'
                }}
            >
                <Table stickyHeader>
                    <TableHead 
                        sx={{
                            backgroundColor: 'white',
                            zIndex: 2,
                            boxShadow: '0px 4px 6px -2px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        <TableRow>
                            <TableCell sx={{fontWeight : 'bold'}}>Stems</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {trackList.map((t, index) => (
                            <TableRow key={index} className='stem-list-row'>
                                <TableCell>
                                    <div className='stem-lead-block'>
                                        <TracksPlayPauseButton track={t}/>
                                        <div className='stem-list-item'>
                                            {cleanStemName(t.title, parentTrackTitle)}
                                        </div>
                                    </div>
                                </TableCell>
                                <TableCell>
                                    <WaveForm track={t}/>
                                {/* <WaveFormVisualizer track={t} /> */}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    );
}

export default StemList;